// extracted by mini-css-extract-plugin
module.exports = {"preview__image":"preview-section_preview__image__8eaWi"};